import { render, staticRenderFns } from "./AddStudentToFamilyModal.vue?vue&type=template&id=820fb888&"
import script from "./AddStudentToFamilyModal.vue?vue&type=script&lang=js&"
export * from "./AddStudentToFamilyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports